export function DetailIcon({ name }) {
    return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {name === 'back' ? <path d="m12 5-7 7 7 7M5 12h14" />
            : name === 'close' ? <path d="m6 6 12 12M18 6 6 18" />
                : name === 'search' ? <><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 4 4" /></>
                    : <><circle cx="12" cy="8" r="3" /><path d="M5 21v-2a7 7 0 0 1 14 0v2" /></>}
    </svg>;
}

export function DetailModalControls({ onBack, onClose }) {
    return <div className="esd-modal-actions">
        {onBack && <button type="button" className="esd-modal-action" onClick={onBack} aria-label="Back" title="Back"><DetailIcon name="back" /></button>}
        <button type="button" className="esd-modal-action" onClick={onClose} aria-label="Close details" title="Close"><DetailIcon name="close" /></button>
    </div>;
}
